import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { loggedUserIdSelector } from '../../../redux/context/selectors';
import { selectEditedUserErrors } from '../../../redux/profiles/selectors';
import { changePasswordActions } from '../../../redux/auth/changePassword/actions';
import { selectChangePasswordProcessFormData } from '../../../redux/auth/changePassword/selectors';

const mapStateToProps = state => ({
  errors: selectEditedUserErrors(state),
  loggedUserId: loggedUserIdSelector(state),
  changePasswordFormData: selectChangePasswordProcessFormData(state),
});

const mapDispatchToProps = {
  proceed: changePasswordActions.proceed,
};

export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
);



// WEBPACK FOOTER //
// ./src/components/Auth/ChangePassword/enhance.js